export default __webpack_public_path__ + "static/media/arrow_dropdown_up_black.ee494c0e.svg";